import React from 'react';
import PropTypes from 'prop-types';
import MuiButton from '@material-ui/core/Button';

import { useTranslation } from 'utils/modifiedTranslation';
import useStyles from './styles';

/**
 * A button the uses the secondary theme with contained variant (from material ui)
 */
const SecondaryContainedButton = (props) => {
  const { label, onClick, isDisabled } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <MuiButton className={classes.root} onClick={onClick} color="secondary" disabled={isDisabled}>
      {t(label)}
    </MuiButton>
  );
};

SecondaryContainedButton.propTypes = {
  /**
   * Label of the button. If not passed then only icon will be displayed
   */
  label: PropTypes.string,
  /**
   * Function to call when button clicked
   */
  onClick: PropTypes.func.isRequired,
  /**
   * If button should be disabled
   */
  isDisabled: PropTypes.bool,
};

export default SecondaryContainedButton;
